import Model from 'src/app/common/model';
import SensorTypeModel from './sensorType.model';
import QueryParamsModel from './queryParams.model';

export default class SensorModel extends Model {
  sensorType: SensorTypeModel;
  qp: QueryParamsModel;
  name?: string;
  vendor_name?: string;
  qp_id: number;
  sensor_type_id: number;
  created_name: string;
  updated_name: string;
  iseditable: boolean;

  constructor() {
    super();
  }
}
